<template>
  <div>
    <b-row>
      <b-col
        xl="3"
        md="6"
      >
        <b-card
          class="card-tiny-line-stats"
          body-class="pb-100"
        >
          <div class="d-flex justify-content-between align-content-center mb-2">
            <h5>
              {{ $t('Loan Status And Balances') }}
            </h5>
          </div>

          <h2
            class="font-weight-bolder mb-5"
            style="font-size:32px; font-weight: 600; color: black;"
          >
            &#8358;0
          </h2>
        </b-card>
      </b-col>
      <b-col
        xl="9"
        md="6"
      >
        <b-card
          no-body
          class="card-statistics"
        >
          <b-card-header>
            <h5>{{ $t('Supplementary Financing Agreement Tracker') }}</h5>
            <feather-icon
              icon="RotateCwIcon"
              class="cursor-pointer"
              @click="fetchSFATracker"
            />
          </b-card-header>
          <b-card-body
            class="card-resize"
          >
            <b-row>
              <b-col
                xl="4"
                sm="6"
              >
                <b-card
                  class="card card-supplementary-1"
                >
                  <div>
                    <h5 class="text-white text-capitalize">
                      <span style="font-size:25px; font-weight: 600; color: black;">{{ sfaTracker.collateralValue }}</span>

                    </h5>
                    <b-card-text
                      style="font-size:11px; font-weight: 600;"
                      class="text-white"
                    >
                      Total Plegded Collateral Value
                    </b-card-text>
                  </div>

                </b-card>
              </b-col>
              <b-col
                xl="4"
                sm="6"
              >
                <b-card
                  class="card card-supplementary-2"
                >
                  <div>
                    <h5 class="text-white text-capitalize">
                      <span style="font-size:25px; font-weight: 600; color: black;">{{ sfaTracker.utilizedCollateral }}</span>

                    </h5>
                    <b-card-text
                      style="font-size:11px; font-weight: 600;"
                      class="text-white"
                    >
                      Ultilized Collateral
                    </b-card-text>
                  </div>

                </b-card>
              </b-col>
              <b-col
                xl="4"
                sm="6"
              >
                <b-card
                  class="card card-supplementary-3"
                >
                  <div>
                    <h5 class="text-white text-capitalize">
                      <span style="font-size:25px; font-weight: 600; color: black;">{{ sfaTracker.availableCollateralPercentage >= 0 ? `${sfaTracker.availableCollateralPercentage}%` : '' }}</span>

                    </h5>
                    <b-card-text
                      style="font-size:11px; font-weight: 600;"
                      class="text-white"
                    >
                      Available Collateral Percentage
                    </b-card-text>
                  </div>

                </b-card>
              </b-col>
            </b-row>
          </b-card-body>
          <Spinner :show="isLoadingSFATracker" />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardText, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import { onMounted, ref } from '@vue/composition-api'
import { useActions } from 'vuex-composition-helpers'
import Spinner from '@/views/components/spinner/Spinner.vue'
import useToastAlert from '../../../composable/useToast'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardText,
    BCardBody,
    Spinner,
  },
  setup() {
    const { getSFATracker } = useActions({ getSFATracker: 'dashboard/getCreditLimitOverview' })
    const { toastAlert } = useToastAlert()
    const sfaTracker = ref([])
    const isLoadingSFATracker = ref(false)

    const fetchSFATracker = async () => {
      try {
        isLoadingSFATracker.value = true
        const response = await getSFATracker({ permission: 'VIEW_PFI_DASHBOARD' })

        const { status, data } = response
        if (status === 200 && data.pfiData !== null) {
          sfaTracker.value = data.pfiData
          isLoadingSFATracker.value = false
        }
      } catch (err) {
        toastAlert(err)
      } finally {
        isLoadingSFATracker.value = false
      }
    }

    onMounted(async () => {
      await fetchSFATracker()
    })

    return {
      sfaTracker,
      fetchSFATracker,
      isLoadingSFATracker,
    }
  },
}
</script>

<style lang="scss" scoped>
    .card-supplementary-1 {
    background: #b388dd;
    color: white;
  }
  .card-supplementary-2 {
    background: #dbc880;
    color: white;
  }
  .card-supplementary-3 {
    background: #eb6f6f;
    color: white;
  }
  .card-resize {
    margin-top: -10px;
    margin-bottom: -20px;
  }
</style>
